export default __webpack_public_path__ + "static/media/IconToReview.0b564b89.svg";